
















































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { MatchAPI, ResponseStatus } from '@/api/match'
import ServerError from '@/utils/server_error'
import matchStore from '../../match.store'

@Component
export default class MatchAssistanceRequestDialog extends Vue {
  matchModule = getModule(matchStore, this.$store)

  @PropSync('visible', { type: Boolean, default: false })
  isOpen!: boolean

  @Prop({ type: Boolean, default: false }) readonly hidden!: boolean

  // isOpen: boolean = false
  isLoading: boolean = false
  isRequested: boolean = false

  get matchId() {
    return this.matchModule.match!.matchId
  }

  async requestSupport() {
    try {
      const response = await MatchAPI.requestMatchAssistance(this.matchId)
      if (response.data.status === ResponseStatus.Ok) {
        this.isRequested = true
        this.$toast.success(
          this.$t('MatchAssistanceRequestDialog.MatchSupportRequested'),
          {
            dismissable: true
          }
        )
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.warning(err.getMessage(), {
          dismissable: true
        })
      } else {
        console.error(err)
      }
    } finally {
      this.isOpen = false
    }
  }
}
